import { Canvas } from '@react-three/fiber'
import { AdaptiveDpr, Preload } from '@react-three/drei'
import { Scene } from './Scene.jsx'

export function ExpeditionCanvas({ reducedMotion, device }) {
  return <Canvas className="webgl" dpr={device.dpr} camera={{ fov: 38, near: .1, far: 500, position: [0, 12, 30] }}
    shadows={!device.lowPower} gl={{ antialias: !device.lowPower, powerPreference: 'high-performance', alpha: false }}
    onCreated={({ gl }) => { gl.domElement.setAttribute('aria-label', 'Interactive three-dimensional map of Boulder and the Front Range') }}>
    <Scene reducedMotion={reducedMotion} lowPower={device.lowPower} />
    <AdaptiveDpr pixelated /><Preload all />
  </Canvas>
}
